import { Input, Select, useTranslate } from '@prenuvo/halo';

import { AutoHeightTextArea, SelectTooltip } from '@/shared/ui';
import { isEmpty } from '@/shared/util';

import { ABOUT_TYPES, COMMON_STYLES, ISSUE_TYPES } from '../report-issue-handler.constant';
import { AboutType, IssueType } from '../report-issue-handler.model';
import { useReportIssueHandler } from '../use-report-issue-handler.hook';
import { ReportCommonLabel } from './report-common-label.component';

export function ReportFormFields() {
  const {
    aboutType,
    description,
    issueType,
    setAboutType,
    setDescription,
    setIssueType,
    setTitle,
    showErrors,
    title,
  } = useReportIssueHandler();

  const translate = useTranslate();

  return (
    <>
      <div className="flex gap-4">
        <div className="flex-1">
          <ReportCommonLabel
            isRequired
            issueType={issueType}
            labelText="FCT.REPORTING.REPORT_ISSUE.LABEL.WHAT_WOULD_YOU_LIKE_TO_DO"
            showErrors={showErrors}
            title={title}
          />
          <Select
            aria-label="FCT.REPORTING.REPORT_ISSUE.LABEL.WHAT_WOULD_YOU_LIKE_TO_DO"
            className={COMMON_STYLES(showErrors && !issueType).select}
            data-testid="issue-type-select"
            name="issue-type"
            onValueChange={(value: IssueType) => setIssueType(value)}
            options={ISSUE_TYPES}
            tooltip={<SelectTooltip content={issueType} />}
            value={issueType}
            variant="outlined"
          />
        </div>
        <div className="flex-1">
          <ReportCommonLabel
            issueType={issueType}
            labelText="FCT.REPORTING.REPORT_ISSUE.LABEL.WHAT_IS_IT_ABOUT"
            showErrors={showErrors}
            title={title}
          />
          <Select
            aria-label={translate('FCT.REPORTING.REPORT_ISSUE.LABEL.WHAT_IS_IT_ABOUT')}
            className={COMMON_STYLES().select}
            data-testid="about-type-select"
            name="about-type"
            onValueChange={(value: AboutType) => setAboutType(value)}
            options={ABOUT_TYPES}
            tooltip={<SelectTooltip content={aboutType} />}
            value={aboutType}
            variant="outlined"
          />
        </div>
      </div>
      <div>
        <ReportCommonLabel
          isRequired
          issueType={issueType}
          labelText="FCT.REPORTING.REPORT_ISSUE.LABEL.TITLE"
          showErrors={showErrors}
          title={title}
        />
        <Input
          aria-label={translate('FCT.REPORTING.REPORT_ISSUE.LABEL.TITLE')}
          className={COMMON_STYLES(showErrors && isEmpty(title)).input}
          data-testid="issue-title-input"
          onChange={(e) => setTitle(e.target.value)}
          type="text"
          value={title}
        />
      </div>
      <div>
        <ReportCommonLabel
          issueType={issueType}
          labelText="FCT.REPORTING.REPORT_ISSUE.LABEL.DESCRIPTION"
          showErrors={showErrors}
          title={title}
        />
        <AutoHeightTextArea
          aria-label={translate('FCT.REPORTING.REPORT_ISSUE.LABEL.DESCRIPTION')}
          className={COMMON_STYLES().input}
          data-testid="issue-description-textarea"
          onChange={(e) => setDescription(e.target.value)}
          value={description}
          variant="outlined"
        />
      </div>
    </>
  );
}
